import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

interface Block {
  AutoIndex: number;
  startTime: string;
  endTime: string;
  duration: number;
  comment: string;
  isRecurring: boolean;
  daysOfWeek: string;
  repeatUntil: string;
  doctorName: string;
  RoomName: string;
  creatorName: string;
  DocUID: number;
  RID: number;
  creatorUID: number;
}

@Component({
    selector: 'app-blocks-management',
    templateUrl: './blocks-management.component.html',
    styleUrls: ['./blocks-management.component.css'],
    standalone: false
})
export class BlocksManagementComponent implements OnInit {
  blocks: Block[] = [];
  loading = false;
  displayedColumns: string[] = ['startTime', 'endTime', 'duration', 'resource', 'creator', 'isRecurring', 'comment', 'actions'];

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.loadBlocks();
  }

  loadBlocks(): void {
    this.loading = true;
    this.http.get<{ blocks: Block[] }>('/api/block/all').subscribe(
      (response) => {
        this.blocks = response.blocks;
        this.loading = false;
      },
      (error) => {
        console.error('Error loading blocks:', error);
        this.snackBar.open(this.translate.instant('blocks.messages.Error loading blocks'), this.translate.instant('blocks.gui.buttons.Close'), { duration: 3000 });
        this.loading = false;
      }
    );
  }

  deleteBlock(block: Block): void {
    if (confirm(this.translate.instant('blocks.messages.Are you sure you want to delete this block'))) {
      this.http.delete(`/api/block/${block.AutoIndex}`).subscribe(
        () => {
          this.snackBar.open(this.translate.instant('blocks.messages.Block deleted successfully'), this.translate.instant('blocks.gui.buttons.Close'), { duration: 3000 });
          this.loadBlocks();
        },
        (error) => {
          console.error('Error deleting block:', error);
          this.snackBar.open(this.translate.instant('blocks.messages.Error deleting block'), this.translate.instant('blocks.gui.buttons.Close'), { duration: 3000 });
        }
      );
    }
  }

  formatDate(date: string): string {
    return new Date(date).toLocaleString('he-IL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatTime(date: string): string {
    return new Date(date).toLocaleTimeString('he-IL', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getResourceName(block: Block): string {
    if (block.doctorName) {
      return block.doctorName;
    }
    if (block.RoomName) {
      return block.RoomName;
    }
    return this.translate.instant('blocks.messages.Not specified');
  }

  getCreatorName(block: Block): string {
    return block.creatorName || this.translate.instant('blocks.messages.Unknown');
  }

  getDaysOfWeekText(daysOfWeek: string): string {
    if (!daysOfWeek) return '';
    const daysMap: { [key: string]: string } = {
      '0': this.translate.instant('appointments.gui.Days.sunday'),
      '1': this.translate.instant('appointments.gui.Days.monday'),
      '2': this.translate.instant('appointments.gui.Days.tuesday'),
      '3': this.translate.instant('appointments.gui.Days.wednesday'),
      '4': this.translate.instant('appointments.gui.Days.thursday'),
      '5': this.translate.instant('appointments.gui.Days.friday'),
      '6': this.translate.instant('appointments.gui.Days.saturday')
    };
    return daysOfWeek.split(',').map(d => daysMap[d] || d).join(', ');
  }
}
